import React, { Component, Fragment } from 'react';
import SquarePaymentForm, {
  CreditCardCVVInput,
  CreditCardExpirationDateInput,
  CreditCardNumberInput,
  CreditCardPostalCodeInput,
  CreditCardSubmitButton,
} from 'react-square-payment-form';

import SignUpWrapper from 'containers/SignUpWrapper';
import { TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import { checkValidity, handleFormValidate } from 'utils/formvalidate';
import UsersApi from 'apis/Users';
import {
  setContactDetails,
  setNonce,
  removeNonce,
  removeBillingDetails,
} from 'constants/localStorageManager';
import CardImage from 'assets/img/credit-card-payment.jpg';
import 'assets/scss/paymentForm.css';
import 'assets/scss/soonoGetStarted.css';

import InputField from './InputField';
import PaymentStepAddress from './PaymentStepAddress';
import ReviewSubscription from './ReviewSubscription';

const assignFormValuetoKeys = formValues => {
  const formKeys = Object.keys(formValues);
  const formData = {};

  formKeys.forEach(key => {
    formData[key] = formValues[key].value;
  });

  return formData;
};

class PaymentStep extends Component {
  constructor() {
    super();
    this.state = {
      formValues: {
        name: {},
      },
      nonceGenerated: false,
      errorMessages: [],
    };
  }

  componentDidMount() {
    console.log(this.props)
    removeNonce();
    removeBillingDetails();
  }

  handleSubmit = e => {
    e.preventDefault();
    const form = this.refs.signupForm;
    const { hasErrors, formValues } = handleFormValidate(form);
    this.setState({ hasErrors, formValues });
    if (!hasErrors) this.updateContactDetails();
  };

  updateContactDetails = () => {
    const { location } = this.props;
    const { formValues } = this.state;
    const contactDetails = assignFormValuetoKeys(formValues);
    const {
      email,
      firstName: first_name,
      lastName: last_name,
      phone: phone_number,
    } = contactDetails;

    UsersApi.addNewUser({ first_name, last_name, phone_number, email })
      .then(({ data }) => {
        setContactDetails(data);
        this.changeStep(location.pathname);
      })
      .catch(err => {
        console.log(err);
      });
  };

  changeStep = currentPathName => {
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    this.props.history.push(nextStep.path);
  };

  handleChange = e => {
    const { name, value, required, type } = e.target;
    const _state = { ...this.state };
    const hasError = checkValidity({ name, value, type, required });
    _state.formValues[name] = {
      value,
      hasError,
    };

    this.setState({ ..._state });
  };

  saveNonce = (nonce, cardData) => {
    console.log(cardData);
    const { billing_postal_code } = cardData;
    const {
      formValues: { name },
    } = this.state;
    setNonce({ nonce, billing_name: name.value, zip: billing_postal_code });
    this.setState({ nonceGenerated: true });
  };

  validate = value => {
    if (!value) return false;
    var regex = /^[a-zA-Z ]{2,30}$/;
    return regex.test(value);
  };

  checkNameOnSubmit = () => {
    const {
      formValues: { name },
    } = this.state;
    if (!this.validate(name.value)) {
      const _name = { ...name, hasError: true };
      const _formValues = {};
      _formValues.name = _name;
      const formValues = { ...this.state.formValues, ..._formValues };
      this.setState({ formValues });
      return false;
    }
    return true;
  };

  handleNonce = (errors, nonce, cardData, buyerVerificationToken) => {
    const isNameValid = this.checkNameOnSubmit();
    if (errors) {
      this.setState({ errorMessages: errors });
      return;
    }
    if (!isNameValid) return;
    this.setState({ errorMessages: [] });
    this.saveNonce(nonce, cardData);
  };

  render() {
    const { location, renew } = this.props;
    const { formValues, errorMessages, nonceGenerated } = this.state;
    const errors = {};
    errorMessages.map(error => (errors[error.field] = error));

    // return <ReviewSubscription />

    if (nonceGenerated) {
      return <PaymentStepAddress renew={renew} />;
    }

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.CONTACT_DETAILS}
        currentStep={location.pathname}
        renew={renew}
      >
        <div className="col-md-6 offset-md-3">
          <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
            Enter your payment details
          </h3>
          <p className="text-secondary">
            Your payment method will be applied to your next billing cycle.
          </p>
          <form
            ref="signupForm"
            className="form mt-4 mb-5 text-left text-dark soono-transaction-form"
          >
            <div className="row">
              <div className="form-group col">
                <InputField
                  formValues={formValues}
                  type="text"
                  label="Name on card"
                  placeholder=""
                  name="name"
                  handleChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <div className="my-1 mb-2">
              <SquarePaymentForm
                applicationId={process.env.REACT_APP_SQUARE_APP_ID}
                sandbox={process.env.REACT_APP_SQUARE_ENV == "development"}
                cardNonceResponseReceived={this.handleNonce}
              >
                <fieldset className="sq-fieldset">
                  <CreditCardNumberInput />
                  <div className="row error">
                    {errors.cardNumber && (
                      <span key={`sq-error-${errors.cardNumber.message}`}>
                        {errors.cardNumber.message}
                      </span>
                    )}
                  </div>
                  <div className="sq-form-third">
                    <CreditCardExpirationDateInput />
                    <div className="row error">
                      {errors.expirationDate && (
                        <span key={`sq-error-${errors.expirationDate.message}`}>
                          {errors.expirationDate.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="sq-form-third">
                    <CreditCardPostalCodeInput />
                    <div className="row error">
                      {errors.postalCode && (
                        <span key={`sq-error-${errors.postalCode.message}`}>
                          {errors.postalCode.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="sq-form-third">
                    <CreditCardCVVInput />
                    <div className="row error">
                      {errors.cvv && (
                        <span key={`sq-error-${errors.cvv.message}`}>
                          {errors.cvv.message}
                        </span>
                      )}
                    </div>
                  </div>
                </fieldset>
                <CreditCardSubmitButton>
                  Enter your billing address
                </CreditCardSubmitButton>
              </SquarePaymentForm>
            </div>
            <div className="row">
              <div className="col-md-7">
                <p className="text-center text-secondary d-block mt-2">
                  7 Day Free Trial. Cancel at Anytime!
                </p>
              </div>
              <div className="col-md-4 offset-md-1">
                <img className="card-payment-img" src={CardImage} />
              </div>
            </div>
          </form>
        </div>
      </SignUpWrapper>
    );
  }
}

export default PaymentStep;



// WEBPACK FOOTER //
// ./src/components/transactions/PaymentStep.js